<template>
  <div class="nav">
    <div class="nav-content">
      <ul>
        <li class="logo">
          <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/e8eb8c7cdae374f15933ec447af54f54.png" alt="">
        </li>
        <li
          :class="{'active': currentMenu.type === menu.type}"
          v-for="menu in menus"
          :key="menu.type"
          @click="selectMenu(menu)">
          <img class="icon" :src="menu.icon" alt="">
          <span>{{menu.name}}</span>
        </li>
        <li class="logout" @click="logout">
          <img
            class="icon"
            src="https://vanthink.oss-cn-qingdao.aliyuncs.com/94933a6aff574daae22555c8f1799ad6.png"
            alt="">
          <span>退出</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import utils from '@/services/utils';
import accountApi from '@/api/graphql/account';
import api from '@/api/graphql/statistic';
import courseApi from '@/api/course';


export default {
  props: {
    scene: {
      type: String,
      default: '',
    },
  },
  watch: {
    scene() {
      if (this.scene === 'selectCourse') {
        /* eslint-disable prefer-destructuring */
        this.currentMenu = this.menus[1];
      }
    },
  },
  data() {
    return {
      menus: [
        {
          icon: 'https://vanthink.oss-cn-qingdao.aliyuncs.com/738e0d1f5294310c85849e89f241385b.png',
          name: '首页',
          type: 'index',
        },
        {
          icon: 'https://vanthink.oss-cn-qingdao.aliyuncs.com/a78081b4280262e9422e7596523240e5.png',
          name: '选课',
          type: 'selectCourse',
        },
        {
          icon: 'https://vanthink.oss-cn-qingdao.aliyuncs.com/726b3a0e2db503fa6336844bd74d71b7.png',
          name: '报告',
          type: 'report',
        },
        {
          icon: 'https://vanthink.oss-cn-qingdao.aliyuncs.com/b0ce7b46881e5ee27b04988524bb916f.png',
          name: '我的',
          type: 'personal',
        },
      ],
      currentMenu: {},
      annalsDialogVisible: false,
    };
  },
  created() {
    const [firstMenu] = this.menus;
    this.currentMenu = firstMenu;
  },
  methods: {
    selectMenu(menu) {
      if (menu.type === 'selectCourse' || menu.type === 'report') {
        courseApi.verifyCourseListIsExist({
          type: menu.type,
        })
          .then(() => {
            this.currentMenu = menu;
            this.$emit('change', {
              scene: menu.type,
            });
          });
      } else {
        this.currentMenu = menu;
        this.$emit('change', {
          scene: menu.type,
        });
      }
    },
    logout() {
      accountApi
        .logout()
        .then(({ logout }) => {
          const { url } = logout;
          utils.logout(url);
        });
    },
    openReport() {
      api.getCourseReportLabelList()
        .then(({ CourseReportLabelList }) => {
          if (!CourseReportLabelList.length) {
            utils.error('您暂未订阅课程，请先联系老师订阅课程！');
          } else {
            this.$router.push({
              path: '/learning-center/report',
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/breadcrumb.scss';
  .nav {
    width: $nav-width;
    min-width: 80px;
    height: 100%;
    background-color: $primary;
    .nav-content {
      width: 100%;
      height: 100%;
      ul {
        position: relative;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        margin: 0;
        padding: 0;
        list-style: none;
        .logo {
          margin: 40px 0 60px;
          &:hover {
            background: inherit;
            cursor: auto;
          }
        }
        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 80px;
          text-align: center;
          color: #fff;
          cursor: pointer;
          i {
            font-size: 32px;
          }
          .icon {
            padding: 8px;
            width: 32px;
            border-radius: 8px;
          }
          span {
            display: block;
            margin-top: 5px;
            font-size: 13px;
          }
          &:hover {
            background-color: $primary-light;
          }
          &.active {
            .icon {
              background: #a1a2f8;
            }
          }
        }
        .logout {
          position: absolute;
          left: 50%;
          bottom: 10%;
          transform: translateX(-50%);
        }
      }
    }
  }
</style>
